<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" fill="none" viewBox="0 0 6 10"><path fill="#fff" d="M2.066 5.473a.667.667 0 0 1 0-.947l3.06-3.053a.667.667 0 1 0-.94-.947l-3.06 3.06a2 2 0 0 0 0 2.827l3.06 3.06a.667.667 0 0 0 .94-.947l-3.06-3.053Z"/></svg>
</template>
<script>
export default {
  name: "IconArrow"
}
</script>